module.exports = __webpack_public_path__ + "static/media/21153985726f011c4743bddde2cec195.21153985.webp";